"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Field_1 = __importDefault(require("../../componentReusable/Field"));
const styled_components_1 = require("styled-components");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const helpers_1 = require("../../helpers");
const member_1 = require("../../dataLayer/apisWithoutCache/membersApi/member");
const constants_1 = require("../../constants");
const auth_1 = __importDefault(require("../../auth"));
const tgtHelper_1 = require("../../helpers/tgtHelper");
const onKeyPress_1 = __importDefault(require("../../utils/misc/onKeyPress"));
const styles_styled_1 = require("./styles.styled");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const ChangePhoneNumberScreen = () => {
    const [error, setError] = (0, react_1.useState)("");
    const { translations, isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    (0, react_1.useEffect)(() => {
        dispatch({
            phone: "",
            flow_type: constants_1.LoginAndRegistrationOtpActions.ACTION_EDIT_MOBILE
        });
    }, []);
    const onSubmitChangePhone = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        (0, loggingActions_1.accountChangeMobileSubmitAction)({ memberId: (_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id });
        const body = {
            phone_number: flowState.phone,
            country_code: flowState.country.phone_code,
        };
        (0, member_1.changePhoneNumber)(body)
            .then(() => {
            dispatch({
                screenType: constants_1.ScreenConstants.NEW_USER,
            });
        })
            .catch((e) => {
            var _a;
            if (e.code === constants_1.PHONE_NUMBER_ALREADY_USED) {
                (0, loggingActions_1.accountChangeMobileUsedAction)({ memberId: (_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id });
                dispatch({
                    screenType: constants_1.ScreenConstants.CONFIRMATION_SCREEN,
                    confirmationScreen: {
                        title: translations.mobileNumberUsed,
                        description: translations.mobileNumberUsedP,
                        callBack: onConfirmCb,
                    },
                });
            }
            else {
                setError(e.message);
            }
        });
    });
    const onConfirmCb = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        (0, loggingActions_1.accountChangeMobileRedirectAction)({ memberId: (_b = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _b === void 0 ? void 0 : _b.id });
        const authInstance = auth_1.default.getInstance();
        yield authInstance.destroy();
        authInstance.auth = yield (0, tgtHelper_1.generateRequiredCookiesAndGetToken)(authInstance.platform);
        dispatch({
            screenType: constants_1.ScreenConstants.RETURNING_USER,
            phone: flowState.phone,
        });
    });
    (0, onKeyPress_1.default)("Enter", onSubmitChangePhone, null, flowState);
    return ((0, jsx_runtime_1.jsxs)(styles_styled_1.ChangePhoneNumberCont, Object.assign({ id: "changePhoneNumberScreen" }, (0, helpers_1.classNames)(isDesktop && "width-460 border radius-8"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("p-16 whiteBg mb-16", isMobile && "pt-0", isDesktop && 'changePhoneNoHeaderDesktop'), { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "font-24" }, { children: translations.changeMobileNumber })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "font-14 mt-8" }, { children: translations.changeMobileNumberP }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("grayBg p-16", isDesktop && 'changePhoneNoFormDesktop'), { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "whiteBg p-16 radius-8 fullShadow" }, { children: (0, jsx_runtime_1.jsx)(Field_1.default, { type: "tel", label: translations.mobileNumber, onChangeCb: (phoneNumber) => dispatch({ phone: phoneNumber }), onClearCb: () => dispatch({ phone: "" }), error: error, value: flowState.phone, withCountryCode: true, autoFocus: true }) })), (0, jsx_runtime_1.jsx)("button", Object.assign({}, (0, helpers_1.classNames)("blueBtn block p-16 mt-16 font-17", flowState.phone.length < 1 && "disabled"), { onClick: onSubmitChangePhone }, { children: translations.next }))] }))] })));
};
exports.default = ChangePhoneNumberScreen;
